{
  "title": "سلة المحذوفات",
  "typeLabel": "النوع",
  "restore": "استعادة",
  "columns": {
    "number": "الرقم",
    "date": "التاريخ",
    "branch": "الفرع",
    "employee": "الموظف",
    "amount": "المبلغ",
    "deletedAt": "تاريخ الحذف",
    "deletedBy": "حذف بواسطة",
    "employeePhone": "رقم هاتف الموظف",
    "customer": "العميل",
    "product": "النوع",
    "barrelPrice": "سعر البرميل",
    "jerrycanPrice": "سعر الجركل"
  },
  "types": {
    "REVOLVING_BALANCE": "الأرصدة المدورة",
    "SALE": "المبيعات",
    "PURCHASE": "المشتريات",
    "DEBT_MOVEMENT": "مبيعات الذمم",
    "PAYMENT": "المدفوعات",
    "RECEIPT": "المقبوضات",
    "DEBTOR": "عملاء الذمم"
  },
  "confirmRestore": {
    "title": "استعادة السجل؟",
    "description": "سيتم استعادة السجل رقم {{number}}.",
    "descriptionDebtMovement": "سيتم استعادة السجل رقم {{number}} وإعادة تطبيق أثره على رصيد المدين."
  },
  "toasts": {
    "restored": "تم استعادة السجل بنجاح",
    "deleted": "تم حذف السجل نهائيا"
  },
  "empty": {
    "noResults": "لا توجد نتائج",
    "noData": "لا توجد بيانات محذوفة من هذا النوع"
  },
  "products": {
    "DIESEL": "محروقات",
    "PETROL": "بنزين"
  },
  "deletePermanently": "حذف نهائيا",
  "confirmDelete": {
    "title": "حذف السجل نهائيا؟",
    "description": "سيحذف السجل {{number}} من {{type}} نهائيا ولا يمكن استعادته."
  }
}
